import safeFetch from 'lib/requests/fetch';
import { ICompanyView } from 'lib/types/company';
import { IAdminOnboardingInfo, OnboardingStep } from './types';

export const completeOnboarding = () =>
  safeFetch<ICompanyView>('/admin/account/onboarding/complete', {
    method: 'POST',
  });

export const completeStep = (step: OnboardingStep) =>
  safeFetch<ICompanyView>('/admin/account/onboarding/complete-step', {
    method: 'POST',
    body: JSON.stringify({ onboardingStep: step }),
  });

export const getOnboardingInfo = () =>
  safeFetch<IAdminOnboardingInfo>('/admin/account/onboarding');
